<template><div><h1 id="segmentierung" tabindex="-1"><a class="header-anchor" href="#segmentierung"><span>Segmentierung</span></a></h1>
<p>Segmentierung — Selektion von Personen mit verschachtelten Segmenten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mittels einer Segmentierung werden Personen anhand von Filterkriterien in verschiedene Segmente unterteilt.</p>
<p>Pfad: <code v-pre>Personen → Segmentierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Segmentierung</dt>
<dd>Eindeutige Bezeichnung der Segmentierung. Durch die Verwendung von Punkten (z.B. 2017.Aprilmailing) kann eine neue Hierarchie-Ebene erstellt werden. Im Beispiel würde eine neue Segmentierung &quot;Aprilmailing&quot; unterhalb der Hierarchiestufe &quot;2017&quot; angelegt werden.</dd>
<dt>Beschreibung</dt>
<dd>Eine längere Beschreibung der Segmentierung.</dd>
<dt>Exportpfad</dt>
<dd>Verzeichnis (auf dem <span class="emphasis"><em><span class="application">funtrade</span></em></span> Server) für den Export der Daten.</dd>
<dt>Anrede</dt>
<dd>Definiert, ob im Export Einzelanreden oder Haushaltsanreden verwendet werden sollen.</dd>
<dt>Anredeset</dt>
<dd>Wenn für den Export ein <a class="link" href="ft.refdata.tblanredesets.html" title="Anredesets">Anredeset</a> berücksichtigt werden soll, kann es hier definiert werden.</dd>
<dt>Status</dt>
<dd>Status der Segmentierung. Folgende Status sind möglich
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>nicht markiert</td>
<td>Die Segmentierung ist nicht markiert, mindestens ein Segment ist nicht markiert.</td>
</tr>
<tr>
<td>Markierung läuft</td>
<td>Die Markierung ist am laufen.</td>
</tr>
<tr>
<td>Fehler</td>
<td>Die Segmentierung konnte nicht markiert werden.</td>
</tr>
<tr>
<td>markiert</td>
<td>Die Segmentierung ist vollständig markiert.</td>
</tr>
<tr>
<td>markiert, verknüpft</td>
<td>Die Segmentierung ist vollständig markiert und mit Ereignissen verknüpft.</td>
</tr>
</tbody>
</table>
</dd>
<dt>markiert am</dt>
<dd>Markierungsdatum der Segmentierung.</dd>
<dt>Notizen</dt>
<dd>Notizen zur Segmentierung.</dd>
<dt>Referenzwerte</dt>
<dd>Diese Werte können in den <a class="link" href="ft.refdata.adrfilterpos.html" title="Filterpositionen (Personen)">Filterpositionen</a> verwendet werden (z.B. Tagesdatum oder ein Personenmerkmal).</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="gesamtproduktion" tabindex="-1"><a class="header-anchor" href="#gesamtproduktion"><span>Gesamtproduktion...</span></a></h3>
<p>Die Schritte markieren, Ereignisse verknüpfen und exportieren können mit der Funktion <RouteLink to="/referenz/refs/ft.refproc.sgmgprod.html" title="Gesamtproduktion der Segmentierung">Gesamtproduktion...</RouteLink> in einem Prozess ausgeführt werden.</p>
<h3 id="markieren" tabindex="-1"><a class="header-anchor" href="#markieren"><span>Markieren...</span></a></h3>
<p>Markiert die Segmentierung mit allen Segmenten und Subsegmenten. Siehe <RouteLink to="/referenz/refs/ft.refproc.sgmmark.html" title="Segmente markieren">Markieren...</RouteLink>.</p>
<h3 id="markierung-aufheben" tabindex="-1"><a class="header-anchor" href="#markierung-aufheben"><span>Markierung aufheben...</span></a></h3>
<p>Löscht die Markierung aller Segmente und Subsegmente.</p>
<h3 id="ereignis-verknupfen" tabindex="-1"><a class="header-anchor" href="#ereignis-verknupfen"><span>Ereignis verknüpfen...</span></a></h3>
<p>Verknüpft alle Personen in den zu exportierenden Segmenten mit dem zugeordneten Ereignis. Siehe <RouteLink to="/referenz/refs/ft.refproc.sgmereig.html" title="Segmentierung/Segment mit Ereignis verknüpfen">Ereignis verknüpfen...</RouteLink>.</p>
<h3 id="exportieren" tabindex="-1"><a class="header-anchor" href="#exportieren"><span>Exportieren...</span></a></h3>
<p>Exportiert alle Segmente mit Exportdatei (immer nur das unterste in der Segment in der Hierarchie). Siehe <RouteLink to="/referenz/refs/ft.refproc.sgmexp.html" title="Segmente exportieren">Exportieren...</RouteLink>.</p>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Erstellt einen Ausdruck, wahlweise als Segmentierungsstruktur (Struktur mit Bezeichnungen), einzeilig (Segmentbeschreibung) oder Detailausdruck (Segment + Filterpositionen).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/selektionen-mailings.html" title="7. Mailings (Segmentierung)">Mailings (Segmentierung)</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.sgmereig.html" title="Segmentierung/Segment mit Ereignis verknüpfen">Ereignis verknüpfen ...</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.sgmexp.html" title="Segmente exportieren">Exportieren ...</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.sgmgprod.html" title="Gesamtproduktion der Segmentierung">Gesamtproduktion...</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.sgmmark.html" title="Segmente markieren">Markieren...</RouteLink></p>
</div></template>


